import { render } from "./ButtonPayCard.vue?vue&type=template&id=748d765d"
import script from "./ButtonPayCard.vue?vue&type=script&lang=js"
export * from "./ButtonPayCard.vue?vue&type=script&lang=js"

import "./ButtonPayCard.vue?vue&type=style&index=0&id=748d765d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__